const nearbyListings = {
  displayField: 'titleAdmin',
  name: 'Nearby Listings Grid',
  description: '',
  fields: [
    {
      id: 'titleAdmin',
      name: 'Title (admin)',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'nearbyListings',
    version: 2,
    updatedAt: '2023-09-18T21:07:39.151Z'
  }
};
export default nearbyListings;